import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Api_Url } from "../../../config/config";
import axios from "axios";

const LeadsFilter = ({ parentFunctionLeads }) => {
  const [focusedClientId, setFocusedClientId] = useState(false);
  const [inputValueClientId, setInputValueClientId] = useState(null);
  const [focusedEmployeeName, setFocusedEmployeeName] = useState(false);
  const [inputValueEmployeeName, setInputValueEmployeeName] = useState("");
  const [inputSourceByName, setInputSourceByName] = useState(null);
  const [inputSourceByStatus, setInputSourceByStatus] = useState(null);
  const [inputSourceTeamMembers, setInputSourceTeamMembers] = useState(null);
  const [branch, setBranch] = useState([]);
  const [status, setStatus] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [leads, setLeads] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [userId, setUserId] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    LeadsFetchFunctionData();
    handleDataBranchFunc();
    handleDataSourceFunc();
    handleDataStatusFunc();
    handleTeamMembersFunc();
  }, []);

  useEffect(() => {
    const LoginUser = JSON.parse(sessionStorage.getItem("user"))?.id;
    setUserId(LoginUser);
  });

  const LeadsFetchFunctionData = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/Lead/getbyuserid/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log("res", response.data);
      setLeads(response.data);
      parentFunctionLeads(response.data);
    } catch (error) {
      console.error("Error fetching leads", error);
    }
  };

  const handleLabelClickClientId = () => {
    setFocusedClientId(false);
  };

  const handleInputBlurClientId = () => {
    if (!inputValueClientId) {
      setFocusedClientId(false);
    }
  };

  const handleLabelClickEmployeeName = () => {
    setFocusedEmployeeName(true);
  };

  const handleInputBlurEmployeeName = () => {
    if (inputValueEmployeeName === "") {
      setFocusedEmployeeName(false);
    }
  };

  const handleInputChangeEmployeeName = (e) => {
    const value = e.target.value;
    setInputValueEmployeeName(value);
    if (value !== "" && !focusedEmployeeName) {
      setFocusedEmployeeName(true);
    }
  };

  const handleBranchChange = (selectedOption) => {
    setInputValueClientId(selectedOption);
  };

  const handleSourceChange = (selectedOption) => {
    setInputSourceByName(selectedOption);
  };

  const handleTeamMembers = (selectedOption) => {
    setInputSourceTeamMembers(selectedOption);
  };

  const handleStatusChange = (selectedOption) => {
    setInputSourceByStatus(selectedOption);
  };

  const handleSearch = async () => {
    const pageNumber = 1;
    try {
      const filters = [];
      if (inputValueEmployeeName) {
        filters.push(`Mobile=${inputValueEmployeeName}`);
      }
      if (inputSourceTeamMembers && inputSourceTeamMembers.value !== "all") {
        filters.push(`EmployeeId=${inputSourceTeamMembers.value}`);
      }
      if (!inputSourceTeamMembers || inputSourceTeamMembers.value === "all") {
        filters.push(`UserId=${userId}`);
      }
      if (inputValueClientId && inputValueClientId.value !== "all") {
        filters.push(`BranchId=${inputValueClientId.value}`);
      }
      if (inputSourceByName && inputSourceByName.value !== "all") {
        filters.push(`SourceId=${inputSourceByName.value}`);
      }
      if (inputSourceByStatus && inputSourceByStatus.value !== "all") {
        filters.push(`StatusId=${inputSourceByStatus.value}`);
      }
      if (startDate) {
        const normalizedStartDate = new Date(startDate);
        normalizedStartDate.setHours(0, 0, 0, 0);
        filters.push(
          `StartDate=${normalizedStartDate.toISOString().split("T")[0]}`
        );
      }
      if (endDate) {
        const normalizedEndDate = new Date(endDate);
        normalizedEndDate.setHours(23, 59, 59, 999);
        filters.push(
          `EndDate=${normalizedEndDate.toISOString().split("T")[0]}`
        );
      }

      const queryString = filters.length > 0 ? `?${filters.join("&")}` : "";
      const response = await axios.get(
        `${Api_Url}api/v1/Lead${queryString}&PageNumber=${pageNumber}&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );

      setLeads(response.data?.data);
      parentFunctionLeads(response.data?.data);
      // setCurrentPage(pageNumber);
      // setTotalPages(response.data?.totalPages || 1); // Assuming the API response has `totalPages`
    } catch (error) {
      console.log("LeadsFilter data error", error);
    }
  };

  const handleDataBranchFunc = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log("branches", response.data.data);
      setBranch([{ id: "all", name: "Select All" }, ...response?.data?.data]);
    } catch (error) {
      console.log("branch data error", error);
    }
  };

  const handleDataSourceFunc = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Source?PageNumber=1&PageSize=20`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log("sources", response.data.data);
      setStatus([{ id: "all", name: "Select All" }, ...response?.data?.data]);
    } catch (error) {
      console.log("source data error", error);
    }
  };

  const [allStatus, setAllStatus] = useState([]);


  const handleDataStatusFunc = async () => {
    try {
      const response = await axios.get(`${Api_Url}api/v1/Status/all/9`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      console.log("status", response.data.data);
      setAllStatus([
        { id: "all", name: "Select All" },
        ...response?.data?.data,
      ]);
    } catch (error) {
      console.log("status data error", error);
    }
  };

  const handleTeamMembersFunc = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/Team/${userId}/team-members`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log("Team Members", response.data?.data);
      setTeamMembers([
        { id: "all", firstName: "Select", lastName: "All" },
        ...response?.data?.data,
      ]);
    } catch (error) {
      console.log("Team Members Api Error", error);
    }
  };


  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
  };
  

  return (
    <>
      <div className="row filter-row">
        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus focused">
            <Select
              options={branch.map((b) => ({ value: b.id, label: b.name }))}
              value={inputValueClientId}
              onChange={handleBranchChange}
              onFocus={() => setFocusedClientId(true)}
              onBlur={handleInputBlurClientId}
              styles={customStyles}
            />
            <label className="focus-label">Client ID</label>
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <div
            className={
              focusedEmployeeName
                ? "input-block form-focus focused"
                : "input-block form-focus"
            }
          >
            <input
              type="text"
              className="form-control floating"
              value={inputValueEmployeeName}
              onChange={handleInputChangeEmployeeName}
              onFocus={() => setFocusedEmployeeName(true)}
              onBlur={handleInputBlurEmployeeName}
            />
            <label
              className="focus-label"
              onClick={handleLabelClickEmployeeName}
            >
              Employee Name
            </label>
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus focused">
            <Select
              options={teamMembers.map((s) => ({
                value: s.id,
                label: `${s.firstName} ${s.lastName}`,
              }))}
              value={inputSourceTeamMembers}
              onChange={handleTeamMembers}
              styles={customStyles}
            />
            <label className="focus-label">Source by Team Member</label>
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus focused">
            <Select
              options={status.map((s) => ({ value: s.id, label: s.name }))}
              value={inputSourceByStatus}
              onChange={handleStatusChange}
              styles={customStyles}
            />
            <label className="focus-label">Source by Status</label>
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus focused">
            <Select
              options={branch.map((s) => ({ value: s.id, label: s.name }))}
              value={inputSourceByName}
              onChange={handleSourceChange}
              styles={customStyles}
            />
            <label className="focus-label">Source by Name</label>
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <div className="cal-icon">
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              placeholderText="Start Date"
              className="form-control"
            />
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <div className="cal-icon">
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              placeholderText="End Date"
              className="form-control"
            />
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <button
            className="btn btn-success btn-block w-100"
            type="button"
            onClick={handleSearch}
          >
            Apply Filter
          </button>
        </div>

        {/* <div className="col-12 mt-3">
          <div className="pagination-controls d-flex justify-content-between">
            <button
              className="btn btn-secondary"
              onClick={() => handleSearch(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="btn btn-secondary"
              onClick={() => handleSearch(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default LeadsFilter;
